import React from "react";
import icons from "../../../assets/icons/icons";
import "./sms-setup-banner.scss";

const SMSSetUpBanner = () => {
  return (
    <div className="sms-setup-banner">
      <img src={icons.TermOfServicesInfo} alt="info icon" />
      <p className="sms-setup-text">
        <strong>Twilio Setup Required:</strong> Please configure your Twilio account under Company Settings to enable SMS-related features.
      </p>
    </div>
  );
};

export default SMSSetUpBanner;